<vectronic-card
  class="information-dialog"
  [title]="data.title"
  [displayClose]="true"
  (closed)="dialogRef.close()"
>
  <ng-container body>
    <p class="information-dialog__subtitle" [style]="data.textStyle">
      {{ data.text }}
    </p>
    <div class="information-dialog__button-container">
      <button mat-button [mat-dialog-close]="false">OK</button>
    </div>
  </ng-container>
</vectronic-card>
